import clsx from 'clsx'
import { ClassName } from 'types/props'

import { Rule } from '../rule'
import classes from './index.module.scss'

interface FullWidthBarProps extends ClassName {
  align?: 'left' | 'center' | 'right'
  children: React.ReactNode
  shouldPadXAxis?: boolean
  shouldSpaceBetween?: boolean
  showBottomBorder?: boolean
  size?: 'small' | 'medium' | 'large'
}

export const FullWidthBar = ({
  align = 'left',
  children,
  className,
  shouldPadXAxis = true,
  shouldSpaceBetween = false,
  showBottomBorder = true,
  size = 'medium'
}: FullWidthBarProps) => (
  <div className={classes.root}>
    <div
      className={clsx(classes.child, classes[size], classes[align], className, {
        [classes.removePadXAxis]: !shouldPadXAxis,
        [classes.spaceBetween]: shouldSpaceBetween
      })}
    >
      {children}
    </div>
    {showBottomBorder && <Rule />}
  </div>
)
